import { render, staticRenderFns } from "./ExtendedSearch.vue?vue&type=template&id=e061a61c&scoped=true&"
import script from "./ExtendedSearch.vue?vue&type=script&lang=js&"
export * from "./ExtendedSearch.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedSearch.vue?vue&type=style&index=0&id=e061a61c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e061a61c",
  null
  
)

export default component.exports